import { Component, OnInit } from '@angular/core';

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { HayzinvorArchiveNews } from './zinvorArchiveNews';
@Component({
  selector: 'app-zinvor-archive-news',
  templateUrl: './zinvor-archive-news.component.html',
  styleUrls: ['./zinvor-archive-news.component.scss']
})
export class ZinvorArchiveNewsComponent implements OnInit {
  hayzinvorArchiveNews:HayzinvorArchiveNews;
  url ;
curent;
  constructor(private http: HttpClient , private route: ActivatedRoute) {
    var url_string = location.href;
    this.url = url_string;8
    this.curent = url_string.substr(url_string.lastIndexOf('/') + 1);
   }

  ngOnInit() {
    
    this.http.get<HayzinvorArchiveNews>('http://servers.itresources.am/p_n/public/api/archive/hay_zinvor/news/'+ this.curent).subscribe(data => {
      this.hayzinvorArchiveNews = data;
 

    });

  }

}
